import { render, staticRenderFns } from "./TemplateModal.vue?vue&type=template&id=17b5442d"
import script from "./TemplateModal.vue?vue&type=script&lang=js"
export * from "./TemplateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17b5442d')) {
      api.createRecord('17b5442d', component.options)
    } else {
      api.reload('17b5442d', component.options)
    }
    module.hot.accept("./TemplateModal.vue?vue&type=template&id=17b5442d", function () {
      api.rerender('17b5442d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/dining/print/TemplateModal.vue"
export default component.exports